function useLocale() {
  return import.meta.env.LOCALE ?? "de";
}
exports.default = useLocale;
